var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"content-class":"mt-4","nav-class":"border-0"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab',{attrs:{"title":"Member Mobile Apps","active":""}},[_c('MemberTable')],1),_c('b-tab',{attrs:{"title":"Transaksi Mobile Apps"}},[_c('TransactionTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }